// ResultsRoutes.jsx (reemplaza tu route padre por el layout)
import { Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// layout
import ResultsLayout from "../pages/Layout/ResultsLayout";

// páginas
import AnalyzeResultsQuality from "../pages/results/AnalyzeResultsQuality";
import AnalyzeResultsVirulence from "../pages/results/AnalyzeResultsVirulence";
import AnalyzeResultsSccmec from "../pages/results/AnalyzeResultsSccmec";
import AnalyzeResultsDownload from "../pages/results/AnalyzeResultsDownload";
import AnalyzeResultsKaptive from "../pages/results/AnalyzeResultsKaptive";
import AnalyzeResultsMlst from "../pages/results/AnalyzeResultsMlst";
import AnalyzeResultsResistanceResfinder from "../pages/results/AnalyzeResultsResistanceResfinder";
import AnalyzeResultsResistanceRgi from "../pages/results/AnalyzeResultsResistanceRgi";

//Transicion de paginas
import PageTransition from "../shared/components/PageTransition";
import AnalyzeResultsCitations from "../pages/results/AnalyzeResultsCitations";

export default function ResultsRoutes() {
    return (
        <AnimatePresence>
            <Routes>
                <Route path="analyze/results/:id" element={<ResultsLayout />}>
                    {/* /analyze/results/:id -> decide a dónde ir (quality si existe, si no, a la primera disponible) */}
                    <Route index element={<Navigate to="quality" replace />} />

                    <Route
                        path="quality"
                        element={
                            <PageTransition>
                                <AnalyzeResultsQuality />
                            </PageTransition>
                        }
                    />

                    <Route path="resistance">
                        <Route
                            index
                            element={
                                <PageTransition>
                                    <Navigate to="resfinder" replace />
                                </PageTransition>
                            }
                        />
                        <Route
                            path="resfinder"
                            element={
                                <PageTransition>
                                    <AnalyzeResultsResistanceResfinder />
                                </PageTransition>
                            }
                        />
                        <Route
                            path="rgi"
                            element={
                                <PageTransition>
                                    <AnalyzeResultsResistanceRgi />
                                </PageTransition>
                            }
                        />
                    </Route>

                    <Route
                        path="virulence"
                        element={
                            <PageTransition>
                                <AnalyzeResultsVirulence />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="sccmec"
                        element={
                            <PageTransition>
                                <AnalyzeResultsSccmec />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="kaptive"
                        element={
                            <PageTransition>
                                <AnalyzeResultsKaptive />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="mlst"
                        element={
                            <PageTransition>
                                <AnalyzeResultsMlst />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="download"
                        element={
                            <PageTransition>
                                <AnalyzeResultsDownload />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="citations"
                        element={
                            <PageTransition>
                                <AnalyzeResultsCitations mode="dark"/>
                            </PageTransition>
                        }
                    />

                    {/* fallback */}
                    <Route path="*" element={<Navigate to="download" replace />} />
                </Route>
                <Route path="*" element={null} />
            </Routes>
        </AnimatePresence>
    );
}
